/**
 * @generated SignedSource<<25ae936a6c3083d427c26e46085d9714>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpBuyerIncentivesModal_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerIncentives_user">;
  readonly " $fragmentType": "PdpBuyerIncentivesModal_user";
};
export type PdpBuyerIncentivesModal_user$key = {
  readonly " $data"?: PdpBuyerIncentivesModal_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpBuyerIncentivesModal_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpBuyerIncentivesModal_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cd593bc218d5c459e215f735fc4e455f";

export default node;
